import { useTabletContext } from './TabletLayout'

/**
 * Confirmación de identidad, obligatoria en la tablet compartida. El PIN es
 * lo único que identifica al jugador: un typo que caiga justo en el PIN de un
 * compañero lo loguearía en silencio, y las respuestas del cuestionario
 * quedarían atribuidas al trial equivocado del estudio. Que el jugador vea su
 * propio nombre antes de seguir es lo que convierte ese error mudo en un
 * "No soy yo" de un toque.
 */
export function TabletConfirmScreen() {
  const { session, onIdentityConfirmed, endSession } = useTabletContext()
  if (!session) return null

  return (
    <div className="panel max-w-xl p-2xl text-center">
      <p className="m-0 text-base uppercase tracking-wide text-text-muted">Hola</p>
      <h1 className="mt-sm text-2xl text-[var(--club-primary)]">{session.displayName}</h1>
      <p className="mt-md text-lg text-text-secondary">¿Sos vos?</p>

      <div className="mt-xl flex flex-col gap-md">
        <button type="button" className="btn-primary py-lg text-lg" onClick={onIdentityConfirmed}>
          Sí, continuar
        </button>
        <button type="button" className="btn py-lg text-lg" onClick={endSession}>
          No soy yo
        </button>
      </div>
    </div>
  )
}
